<template>
  <button class="switcher-option" :class="{ active: currentSection === section }" @click="emit('select', section)">
    <div class="option-content">
      <div class="option-icon">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <g v-html="getIconPath(icon)"></g>
        </svg>
      </div>
      <div class="option-text">
        <span class="option-title">{{ title }}</span>
        <span class="option-subtitle">{{ subtitle }}</span>
      </div>
    </div>
  </button>
</template>

<script setup>
import { getIconPath } from '@/Modules/utils/icons';

const props = defineProps({
  section: String,
  currentSection: String,
  title: String,
  subtitle: String,
  icon: String,
});

const emit = defineEmits(['select']);
</script>

<style scoped>
.switcher-option {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0;
  background: none;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
  margin-bottom: 0.25rem;
  position: relative;
  overflow: hidden;
}

.switcher-option:last-child {
  margin-bottom: 0;
}

.switcher-option::before {
  content: '';
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.switcher-option:hover::before {
  opacity: 1;
}

.switcher-option:hover {
  transform: translateX(2px);
}

.switcher-option.active {
  background: var(--highlights-background);
}

.option-content {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.6rem 0.75rem;
  width: 100%;
  position: relative;
  z-index: 1;
}

.option-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: #f1f5f9;
  border-radius: 8px;
  flex-shrink: 0;
  color: #64748b;
  transition: all 0.2s ease;
}

.switcher-option:hover .option-icon {
  background: #e2e8f0;
  color: #475569;
}

.switcher-option.active .option-icon {
  background: var(--highlights);
  color: white;
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.25);
}

.option-text {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.option-title {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  line-height: 1.3;
}

.option-subtitle {
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
}

.switcher-option.active .option-title {
  color: var(--highlights);
}

.switcher-option.active .option-subtitle {
  color: var(--highlights);
}

</style>